var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedialibraryAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m861.33 357.49c-8.6445-8.6445-22.664-8.6445-31.309 0-8.6445 8.6445-8.6445 22.664 0 31.309 56.316 56.316 87.332 131.32 87.332 211.2 0 79.875-31.016 154.88-87.332 211.2-8.6445 8.6445-8.6445 22.664 0 31.309 4.3242 4.3242 9.9883 6.4883 15.656 6.4883 5.6641 0 11.332-2.1641 15.652-6.4883 64.68-64.68 100.3-150.8 100.3-242.51-0.003906-91.703-35.621-177.83-100.3-242.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m790.36 428.46c-8.6445-8.6484-22.664-8.6445-31.309-0.003907-8.6484 8.6445-8.6484 22.664 0 31.312 77.32 77.324 77.32 203.14 0 280.46-8.6484 8.6445-8.6484 22.664 0 31.309 4.3203 4.3203 9.9883 6.4844 15.652 6.4844 5.668 0 11.332-2.1641 15.656-6.4844 94.586-94.582 94.586-248.49 0-343.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m719.4 499.43c-8.6445-8.6445-22.664-8.6445-31.309 0-8.6445 8.6445-8.6445 22.664 0 31.309 38.188 38.195 38.188 100.34 0 138.53-8.6445 8.6445-8.6445 22.664 0 31.312 4.3203 4.3203 9.9922 6.4844 15.652 6.4844 5.668 0 11.332-2.1641 15.656-6.4844 55.453-55.453 55.453-145.69 0-201.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.38 513.58v172.84c0 12.23 9.9141 22.141 22.141 22.141h112.79v-217.12h-112.79c-12.227 0-22.141 9.9141-22.141 22.141z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m628.31 311.12c-7.7227-3.668-16.875-2.5508-23.496 2.8594l-187.22 152.93v266.18l187.22 152.93c4.0312 3.2891 8.9961 4.9922 14.012 4.9922 3.2227 0 6.4648-0.70312 9.4844-2.1367 7.7266-3.6602 12.652-11.449 12.652-20.004v-537.74c0-8.5508-4.9258-16.34-12.652-20.004z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedialibraryAudio);
export default __webpack_public_path__ + "static/media/medialibrary-audio.cdae4214260a4fb27bad8ed9838b70e1.svg";
export { ForwardRef as ReactComponent };